export default "__VITE_ASSET__ltjt_VSL__"